module["exports"] = [
  "gmail.com",
  "yahoo.ca",
  "hotmail.com"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_CA/internet/free_email.js
// module id = 1149
// module chunks = 1